import * as A from '../../atoms';
import * as M from '../../molecules';
import * as O from '../../organisms';

import { Color, Type } from '../../ions';

import React from 'react';
import SquareCheckbox from '../../atoms/CheckBox/SquareCheckbox';
import classNames from 'classnames/bind';
import styles from './ApplyButton.module.scss';

const cx = classNames.bind(styles);

const RenderQuestion = (props) => {
  const buttonDeleteDisable = props.minCount;
  const buttonAddDisable = props.maxCount;
  const [inputValue, setInputValue] = React.useState(
    props.type === 'guestQuestion' ? props.item.question ?? '' : props.item.title ?? '',
  );
  const [subInputValue, setSubInputValue] = React.useState(props.item.description ?? '');
  const [checkBoxValue, setCheckBoxValue] = React.useState(props.item.necessary);

  const onInputChangeHandler = (value) => {
    setInputValue(value.currentTarget.value);
    props.type === 'guestQuestion'
      ? props.onQuestionChange(value.currentTarget.value, checkBoxValue)
      : props.onEventOrderChange(value.currentTarget.value, props.item.description ?? '');
  };

  const onSubInputChangeHandler = (value) => {
    setSubInputValue(value.currentTarget.value);
    props.onEventOrderChange(props.item.title ?? '', value.currentTarget.value);
  };

  const onCheckBoxChangeHandler = () => {
    setCheckBoxValue(!props.item.necessary);
    props.onQuestionChange(props.item.question ?? '', !props.item.necessary);
  };

  return (
    <div
      className={cx('question-wrapper', props.noQuestions ? 'no-questions' : '', props.className)}
    >
      {props.item && (
        <>
          <div>
            <A.Typography type={Type.P} color={Color.BLACK} mt={15}>
              {props.no}
            </A.Typography>
            <div
              className={cx(
                'input-container',
                props.blankInput && (props.item?.question === '' || props.item.title === '')
                  ? 'blank-error'
                  : '',
              )}
            >
              <M.Input
                type={'text'}
                onChange={(value) => onInputChangeHandler(value)}
                value={
                  props.type === 'guestQuestion'
                    ? props.item?.question ?? ''
                    : props.item.title ?? ''
                }
                readOnly={props.disabled}
                placeholder={props.subInput ? '제목을 입력해주세요.' : '예) 질문'}
                className={cx('question-input', props.disabled && 'question-disabled-input')}
                maxLength={props.charCount ? 30 : ''}
              />
              {props.requireCheck && (
                <div className={cx('question-actions')}>
                  <label>
                    <SquareCheckbox
                      checked={props.item.necessary}
                      onChange={() => onCheckBoxChangeHandler()}
                      disabled={props.disabled}
                      textElement={
                        <A.Typography
                          type={Type.P}
                          color={props.disabled ? Color.PLACEHOLDER : Color.BLACK}
                          mb={2.5}
                        >
                          필수 답변으로 설정하기
                        </A.Typography>
                      }
                    />
                  </label>
                </div>
              )}
            </div>
            <div
              className={cx(
                'button',
                'button-delete',
                buttonDeleteDisable ? 'button-delete-disable' : '',
              )}
              onClick={() => (buttonDeleteDisable ? null : props.onAddDelete(-1))}
              style={{ cursor: 'pointer' }}
            />
            <div
              className={cx('button', 'button-add', buttonAddDisable ? 'button-add-disable' : '')}
              onClick={() => (buttonAddDisable ? null : props.onAddDelete(1))}
              style={{ cursor: 'pointer' }}
            />
          </div>
          {props.subInput && (
            <div
              className={cx(
                'input-container',
                props.blankInput && props.item.description === '' ? 'blank-error' : '',
              )}
            >
              <M.Input
                type={'text'}
                onChange={(value) => onSubInputChangeHandler(value)}
                value={props.item.description ?? ''}
                readOnly={props.disabled}
                placeholder={'이에 따른 설명을 해주세요.'}
                className={cx('question-input', props.disabled && 'question-disabled-input')}
                maxLength={props.charCount ? 100 : ''}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};
export default RenderQuestion;
